import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import 'moment/locale/vi';
import { languageDetector, missingKeyHandler } from 'i18n/i18n.utils';
import { resources, defaultNS, DEFAULT_LANGUAGE } from 'i18n/i18n.types';

const shouldLogMissingKeys = process.env.NODE_ENV === 'development';

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
    resources,
    ns: ['translation'],
    defaultNS,
    saveMissing: shouldLogMissingKeys,
    missingKeyHandler,
  });

export default i18n;
